// Captures Google Ads / UTM attribution params on landing and forwards them
// into hidden inputs on contact forms so leads carry their source.
//
// Capture step: on every page load, check the URL for tracking params and
// stash them in sessionStorage (scoped to the visit). This means a visitor
// who lands on a product page from an ad and submits the consultation form
// later still carries the original attribution.
//
// Inject step: on DOMContentLoaded, populate any `<input data-utm="…">`
// fields with the stored values. Empty if the visitor never had params.
(function () {
  var KEYS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'gclid',
    'gbraid',
    'wbraid',
  ];
  var STORAGE_KEY = 'gh_attribution';

  function capture() {
    try {
      var params = new URLSearchParams(window.location.search);
      var captured = {};
      var hasAny = false;
      KEYS.forEach(function (k) {
        var v = params.get(k);
        if (v) {
          captured[k] = v;
          hasAny = true;
        }
      });
      if (hasAny) {
        captured.landing_page = window.location.pathname + window.location.search;
        captured.captured_at = new Date().toISOString();
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(captured));
      }
    } catch (e) {
      // sessionStorage may be unavailable (private mode, blocked storage)
    }
  }

  function fillForms() {
    var stored = {};
    try {
      stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      stored = {};
    }
    var inputs = document.querySelectorAll('input[data-utm]');
    inputs.forEach(function (input) {
      var key = input.getAttribute('data-utm');
      if (key === 'landing_page') {
        input.value = stored.landing_page || '';
      } else if (key === 'referrer') {
        input.value = document.referrer || '';
      } else if (stored[key]) {
        input.value = stored[key];
      }
    });
  }

  // Removes empty hidden tracking inputs from a form before submit so the
  // store-owner notification email only lists fields that actually carry
  // attribution data (e.g. an organic visitor's email won't show empty
  // utm_term, gclid, … rows).
  function stripEmptyOnSubmit() {
    document.querySelectorAll('form').forEach(function (form) {
      if (form.dataset.utmStripBound) return;
      if (!form.querySelector('input[data-utm]')) return;
      form.dataset.utmStripBound = '1';
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[data-utm]').forEach(function (input) {
          if (!input.value) input.disabled = true;
        });
      });
    });
  }

  capture();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fillForms();
      stripEmptyOnSubmit();
    });
  } else {
    fillForms();
    stripEmptyOnSubmit();
  }
})();
